import { Link } from "react-router-dom";
import { EmptyState } from "../components";

export function NotFound() {
  return <EmptyState title="There is no page at this address."><Link className="text-brand underline" to="/home">Go to Home</Link></EmptyState>;
}
